import { ITlfActionSetEditorBlocksSearchPanel, TlfContextProps } from "./interface";

/**
 * Replaces the editor block-search panel state.
 *
 * @param state - Current TLF context state.
 * @param action - Set-search-panel action containing the next panel status.
 * @returns Updated state with the editor search panel status replaced.
 */
export const tlf_setEditorBlocksSearchPanel = (
  state: TlfContextProps,
  action: ITlfActionSetEditorBlocksSearchPanel,
): TlfContextProps => ({
  ...state,
  editorBlocksSearchPanelStatus: action.editorBlocksSearchPanelStatus,
});
